import Vue from 'vue';
import Component from 'vue-class-component';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('app', {
      layoutMode: 'layout',
      navTheme: 'theme',
      primaryColor: 'color',
      colorWeak: 'weak',
      fixedHeader: 'fixedHeader',
      fixSiderbar: 'fixSiderbar',
      fixSidebar: 'fixSiderbar',
      contentWidth: 'contentWidth',
      autoHideHeader: 'autoHideHeader',
      sidebarOpened: 'sidebar',
      multiTab: 'multiTab',
    }),
  },
})
export default class Mixin extends Vue {
  layoutMode!: string;
  navTheme!: string;
  primaryColor!: string;
  fixedHeader!: string;
  fixSiderbar!: string;
  fixSidebar!: string;
  contentWidth!: string;
  autoHideHeader!: string;
  sidebarOpened!: string;
  multiTab!: string;

  get isTopMenu(): boolean {
    return this.layoutMode === 'topmenu';
  }
  get isSideMenu(): boolean {
    return this.isTopMenu;
  }
}
